import { Box, Grid} from "@mui/material"
import { Generate } from "./Generate"
import { ReconcileRead } from "../../global/API"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import {Warning} from "../../../../core/global/modal/Warning"
import { BackDrop } from "../../../../core/global/BackDrop"
import { SnakeLoader } from "../../../../core/loader/SnakeLoader"
import { Waypoint } from "react-waypoint"
import moment from "moment"
import { Body } from "./Body"
import { MessageModal } from "../../../../core/global/modal/MessageModal"
import { NoDataFound } from "../../empty/Index"

export const Index = () =>{
    const {session_state, reconciliation_state, tool_state} = useContext(ToolContext)
    const {sessionData, navSession} = session_state
    const {__SESSION} = tool_state
    const {date, loader, isToReconcile, toReconcileList, reconciledList, dateForm, infiniteState, snackBarLoader} = reconciliation_state
    const role = __SESSION.data.uaccess[0].role_name
    const today = moment(new Date()).format('YYYY-MM-DD')

    const branchEodRead = async (loadMore = false) => {
        const qsp = {
            date: date.data === undefined ? today : date.data, 
            date_from: isToReconcile.data && role === "Regular User" ? "" : dateForm.data.date_from === "" ? today : dateForm.data.date_from  , 
            date_to: isToReconcile.data && role === "Regular User"? "" : dateForm.data.date_to === ""? today : dateForm.data.date_to, 
            company_branch_id: sessionData.data.branch_id, 
            company_id: __SESSION.data.uaccess[0].company_id, 
            limit: infiniteState.data.limit, 
            offset: loadMore ? infiniteState.data.offset : 0,
            filter:isToReconcile.data && role === 'Regular User' ? 'to-reconcile': 'reconciled'
        }
        try {
            navSession.set((prev) => ({...prev, isShow:true}))
            const res = await ReconcileRead(qsp)
            if (res.msg === "Not yet submitted") {
                role === "Regular User" &&  loader.set(prev => ({ ...prev, isShowWarningModal: true, warningText: 'Complete EoD Sales Report First!', warningSubText: 'Ensure that the EoD sales report is submitted before proceeding with reconciliation.' }));
            }else if (res.msg === "Already Reconciled") {
                role === "Regular User" && loader.set(p => ({ ...p, isShowWarningModal: true, warningText: 'POS Report Already Submitted!', warningSubText: 'You can check the submitted report in the reconciled tab.' }));
                toReconcileList.set([]);
            }else{
                isToReconcile.data ? toReconcileList.set(res.bs_data) : reconciledList.set(res.bs_data)
                loader.set(prev => ({ ...prev, isShowData: true}));
                
            }
            navSession.set((prev) => ({...prev, isShow:false}))
        } catch (error) {
            console.error("Failed to fetch transfers:", error)
        }
        //eslint-disable-next-line
    }

    const handleGenerate = () => {

        if (isToReconcile.data) {
                toReconcileList.set([])
            if (date.data === undefined || date.data === "") {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Date required to generate data.', type: 'error'});
                return;
            }
        } else {
                reconciledList.set([])
            if (!dateForm.data.date_from || !dateForm.data.date_to) {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Date required to generate data.', type: 'error'});
                return;
            }
            if (dateForm.data.date_from > dateForm.data.date_to) {
                snackBarLoader.set({ ...snackBarLoader.data, snackbar: true, msg: 'Invalid Date.', type: 'error'});
                return;
            }
        }
        branchEodRead();
    };

    useEffect(() => {
        role !== "Regular User" ? isToReconcile.set(false) : isToReconcile.set(true) 
        !sessionData.data.modal && branchEodRead()
        //eslint-disable-next-line  
    }, []);

    return (
        <>  
            {sessionData.data.modal?
                <Box width="100%" display="flex" alignItems="center" justifyContent="center" mt={10} px={2}>
                    <Warning message={"You currently haven't selected a branch"} messageDetails={"Please select the branch at the home tab to encode the end-of-day inventory."} />
                </Box>
            :
                <Box p={3}>
                    <Box mt={2}><Generate handleGenerate={handleGenerate} /></Box>
                    {loader.data.isShowData &&<Box mt={2}><Grid container spacing={2}><Body/><Box height="70px" /></Grid></Box>}
                    {((isToReconcile.data && toReconcileList.data.length === 0) || (!isToReconcile.data && reconciledList.data.length === 0))  &&  <NoDataFound/>}
        
                    {!isToReconcile.data && infiniteState.data.infiniteLoad && (
                        <Waypoint onEnter={() => branchEodRead(true)}>
                            <Box component="strong" mt={5} display="flex" justifyContent="center">
                                <SnakeLoader size="10px" bg="#11783C" distance="0.3rem" />
                                </Box>
                        </Waypoint>
                    )}
                    <BackDrop open={navSession.data.isShow} text={"Fetching Data..."}/>
                    <MessageModal open={loader.data.isShowWarningModal} close={()=>loader.set({...loader.data, isShowWarningModal:false })} text={loader.data.warningText} subtext={loader.data.warningSubText}/>

                </Box>
            } 
            <MessageModal open={loader.data.isShowWarningModal} close={()=>loader.set({...loader.data, isShowWarningModal:false })} text={loader.data.warningText} subtext={loader.data.warningSubText} trigger={true}/>
        </>
    )
}